/**
 * Created by Kris Frenz on 9/1/17.
 */

import $ from 'jquery';

class StickyInfobox {
	/**
	 * takes Outermost DOM Element
	 *
	 * @param domElement
	 */
	constructor(domElement) {
		const $element = $(domElement);
		const config = {
			button: 'sticky-sidebar__button',
			content: 'sticky-sidebar__item',
			state: 'is-hidden'
		};

		this.toggleClass($element, config);
	}

	/**
	 * Simple Class Toggler
	 */
	toggleClass($element, config) {
		$element.find('.' + config.button).each((index, element) => {
			$(element).on('click', function() {
				const $target = $(this).parent('.' + config.content);

				$target.toggleClass(config.state);
			});
		});

		/* this.sidebarBtn.on('click', () => {
				this.sidebarContent.toggleClass(this.isHidden);
			});
			*/
	}
}

export default StickyInfobox;



// WEBPACK FOOTER //
// ./js/modules/stickyContactInfobox.js